import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { storyTellerActions } from '../../actions';
import { FillRatioListActionPayload } from '@bus/storyTeller/typedefs';

export function* fetchRatioList() {
  try {
    yield effects.put(storyTellerActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'storytellers/prompts/images/sizes/' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillRatioListActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(storyTellerActions.fillRatioList(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(storyTellerActions.stopFetching());
  }
}
